import React, { useState , useContext} from "react";
import { useNavigate } from "react-router-dom";
import { successToaster, ErrorToaster } from "../../../utils/toaster";
import Layout from "../layout";
import SignupForm from "./SignupForm";
import AuthContext from "../../../context/AuthContext";
import { Organization, Verify, Extension } from "./pages";
import {
  SIGNUPFORM,
  ORGANIZATIONFIELDS,
} from "../../../utils/data";

import { makeApiCall } from "../../../config";
import { SIGN_UP_CONTENT } from "../../../utils/content";

const errorMsgHandler = (name) =>{
  let res = SIGNUPFORM.find((item)=> item.name == name);
  if (!res) {
    return ORGANIZATIONFIELDS.find((item)=> item.name == name);
  }
  return res;
}

const SignUp = () => {
  const { register, signOut, singInFormValues, setSingInFormValues } = useContext(AuthContext);
  const [sendVerification, setSendVerification] = useState(true);
  const [enableBtn, setEnableBtn] = useState(false);
  const [spinnerBtn, setSpinnerBtn] = useState(false);
  const [progressStatus, setProgressStatus] = useState({
    stepOne: false,
    stepTwo: false,
    stepThree: false,
  });
  const [enableProgress, setEnableProgress] = useState(false);
  const [enablePage, setEnablePage] = useState({
    userInfoPage: true,
    organizationInfoPage: false,
    verifyPage: false,
    extensionPage: false,
  });
  const navigate = useNavigate();

  const usernameRegex = /^[a-zA-Z_ -]{0,20}$/;
  const passwordRegex = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/;
  const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
  const urlRegex = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;
  const phoneNumberRegex = /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  const handleChange = (event) => {
    const { name, value } = event.target;
    let disableBtn = false;

    switch (name) {
      case "username":
        if (value !== "" && !usernameRegex.test(value)) {
          errorMsgHandler(name).errorMsg = "Invalid username";
          disableBtn = true;
        } else {
      errorMsgHandler(name).errorMsg = "";
        }
        break;
      case "email":
        if (value !== "" && !emailRegex.test(value)) {
          errorMsgHandler(name).errorMsg = "Invalid email";
          disableBtn = true;
        } else {
          errorMsgHandler(name).errorMsg = "";
        }
        break;
      case "confirmPassword":
        if (value !== "" && singInFormValues.password !== value) {
          errorMsgHandler(name).errorMsg = "Passwords do not match";
          disableBtn = true;
        } else {
          errorMsgHandler(name).errorMsg = "";
        }
        break;
      case "password":
        if (value !== "" && !passwordRegex.test(value)) {
          errorMsgHandler(name).errorMsg = "Your password must be at least 8 characters long, contain 1 uppercase & 1 lowercase character, 1 number & 1 special case";
          disableBtn = true;
        } else {
          errorMsgHandler(name).errorMsg = "";
        }
        break;
      case "baseUrl":
        if (value !== "" && !urlRegex.test(value)) {
          errorMsgHandler(name).errorMsg = "Please enter a valid URL";
          disableBtn = true;
        } else {
          errorMsgHandler(name).errorMsg = "";
        }
        break;
      case "mobileNumber":
        if (value !== "" && (!phoneNumberRegex.test(value) || value.trim() === '')) {
          errorMsgHandler(name).errorMsg = "Please enter a valid phone number";
          disableBtn = true;
        } else {
          errorMsgHandler(name).errorMsg = "";
        }
        break;
      case "organizationName":
        if (value.trim() === '') {
          errorMsgHandler(name).errorMsg = "Please enter an organization name";
          disableBtn = true;
        } else {
          errorMsgHandler(name).errorMsg = "";
        }
        break;
      case "organizationRoll":
        if (value.trim() === '') {
          errorMsgHandler(name).errorMsg = "Please enter an organization roll";
          disableBtn = true;
        } else {
          errorMsgHandler(name).errorMsg = "";
        }
        break;
      case "env":
        if (value !== "" && !usernameRegex.test(value)) {
          errorMsgHandler(name).errorMsg = "Numbers or special characters are not allowed";
          disableBtn = true;
        } else {
          errorMsgHandler(name).errorMsg = "";
        }
        break;
      default:
        break;
    }

    setEnableBtn(disableBtn);

    if (name) {
      setSingInFormValues({
        ...singInFormValues,
        [name]: value,
      });
    }
  };

  const handleSingUp = async (e) => {
    e.preventDefault();
    try {
      if (!enableBtn) {
        setSpinnerBtn(true);
        const checkExistEmail = await makeApiCall("/api/v1/auth/check/email", 'post', {email: singInFormValues.email});
       if(checkExistEmail.code){ 
        setEnablePage({
          userInfoPage: false,
          organizationInfoPage: true,
        });
        setEnableProgress(true);
        setProgressStatus({
          stepOne: true,
        });
          
        delete singInFormValues.confirmPassword;
      }
    }
    } catch (error) {
      if (error.response && error.response.status === 422) {
        ErrorToaster(error.response.data.message);
      } else {
        ErrorToaster("Authentication failed");
        console.error(error);
      }
    } finally {
      setSpinnerBtn(false);
    }
  };
  const handleOrganization = async (e) => {
    e.preventDefault();
    try {
      if (!enableBtn) {
        setSpinnerBtn(true);
        const checkExistMobileNo = await makeApiCall("/api/v1/auth/check/email", 'post', {mobileNumber: singInFormValues.mobileNumber});
        if(checkExistMobileNo.code){ 
        setEnablePage({
          userInfoPage: false,
          organizationInfoPage: false,
          verifyPage: true
        });
        setProgressStatus({
          stepOne: true,
          stepTwo: true,
        });
          // return register(singInFormValues);
          setSpinnerBtn(false);
      }
    }
    } catch (error) {
      if (error.response && error.response.status === 422) {
        ErrorToaster(error.response.data.message);
      } else {
        ErrorToaster("Something went wrong");
        console.log("error occur in Organization:", error);
      }
      setSpinnerBtn(false);
    }
  };

  const handleVerify = async (e) => {
    // e.preventDefault();
    setSpinnerBtn(true);
    try {
      setProgressStatus({
        stepOne: true,
        stepTwo: true,
        stepThree: true,
      });
      const response = await makeApiCall("/api/v1/auth/sendverification", 'post');
      successToaster(response.message);
      response.code && setSpinnerBtn(false);
      // return navigate('/dashboard/default');
    } catch (error) {
      if (error.response && error.response.status === 422) {
        ErrorToaster(error.response.data.message);
      } else {
        ErrorToaster("Something went wrong");
        console.log("error occurred in verify :", error);
      }
      setSendVerification(false);
    }
    setSpinnerBtn(false);
  };

  const handleSkip = async() =>{
    // if (!Boolean(localStorage.getItem("x-access-token"))){
    //     ErrorToaster("no auth provided")
    //     return signOut("/auth/signin");
    //   }
    setSpinnerBtn(true);
       const registerRes = await register(singInFormValues);
       if (registerRes) {
         return navigate('/dashboard/default');
        }
        localStorage.removeItem("fieldLists");
        setSingInFormValues({});
        setSpinnerBtn(false);
  }

  const handleMultiSelectChange = async(values) =>{
    setSingInFormValues((prev)=>({
      ...prev,
      ['listOfUrlAndEnv']: values,
    }))
  }

  const handleBackToUserInfo = () => {
    setEnablePage({
      userInfoPage: true,
      organizationInfoPage: false,
      verifyPage: false,
      extensionPage: false,
    });
  }

  const handleBackToOrganizationInfo = () => {
    setEnablePage({
      userInfoPage: false,
      organizationInfoPage: true,
      verifyPage: false,
      extensionPage: false,
    });
  }

  return (
    <>
      <Layout enableProgress={enableProgress} progressStatus={progressStatus}>
        {/* <span className="mb-1.5 block font-medium">Welcome</span> */}
        {enablePage.userInfoPage && (
          <>
            <SignupForm
              formValue={singInFormValues}
              formFields={SIGNUPFORM}
              handleSubmit={handleSingUp}
              handleChange={handleChange}
              spinnerBtn={spinnerBtn}
            />
          </>
        )}
        {enablePage.organizationInfoPage && (
          <>
            <Organization
              handleSubmit={handleOrganization}
              setEnableProgress={setEnableProgress}
              handleChange={handleChange}
              heading={SIGN_UP_CONTENT.OrganizationTitle}
              formFields={ORGANIZATIONFIELDS}
              setEnablePage={setEnablePage}
              handleMultiSelectChange={handleMultiSelectChange}
              handleBackToUserInfo={handleBackToUserInfo} // added back button handler
              formValue={singInFormValues} // added to preserve organization fields
              spinnerBtn={spinnerBtn}
            />
          </>
        )}
        {enablePage.verifyPage && (
          <>
            <Verify sendVerification={sendVerification} setSendVerification={setSendVerification} handleSubmit={handleVerify} handleSkip={handleSkip} heading={SIGN_UP_CONTENT.VerifyTitle} content={SIGN_UP_CONTENT.VerifyContent} setEnablePage={setEnablePage} handleBackToOrganizationInfo={handleBackToOrganizationInfo}  spinnerBtn={spinnerBtn}/>
          </>
        )}
        {enablePage.extensionPage && (<Extension/>)}
      </Layout>
    </>
  );
};

export default SignUp;
